import React, { Component } from 'react';
import ButtonIcon from '../../../../common/components/core/ButtonIcon';
import AccessInput from '../../../../common/components/AccessControl/AccessInput';
import Tooltip from '../../../../common/components/core/Tooltip';
import { truncate } from '../../../support/utils';
import { isBidValid } from '../discoAdsUtils';
import { DA_CONTENT_URL_TOOLTIP_CHAR_LIMIT } from '../discoAdsConstants';
import { WRITE_PERMISSIONS } from '../../../routers/RouterServices';

class DiscoAdsTableInputWrapper extends Component {
  state = {
    input: this.props.input,
    showButtons: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.input !== this.props.input) {
      this.setState({
        input: this.props.input,
      });
    }
  }

  _handleInputChange = (e) => {
    const { type } = this.props;
    const { value } = e.target;
    const inputValWithoutDollarSign = value.slice(1);
    this.setState({
      input: type === 'bid' ? `$${inputValWithoutDollarSign}` : value, // user should not be able to delete the dollar sign
    });
  };

  _handleCloseClick = () => {
    const { input } = this.props;
    // reset the state of the input as the input that was passed in as props since user did not confirm change
    this.setState({
      input,
      showButtons: false,
    });
  };

  _handleInputIsInFocus = () => {
    this.setState({
      showButtons: true,
    });
  };

  _handleConfirmUrlUpdate = () => {
    const { onConfirmChange, creativeId } = this.props;
    onConfirmChange({
      id: creativeId,
      content_url: this.state.input,
    });
    this.setState({
      showButtons: false,
    });
  };

  _handleConfirmBidUpdate = () => {
    const { id, onConfirmChange } = this.props;
    const bidStringWithoutDollarSign = this.state.input.slice(1);
    const validBid = isBidValid(bidStringWithoutDollarSign);
    if (!validBid) {
      return this._handleCloseClick();
    }
    const bid = Number(bidStringWithoutDollarSign);
    const bidToTwoDecimals = Math.floor(bid * 100) / 100;
    onConfirmChange({
      id,
      bid: bidToTwoDecimals,
    });
    this.setState({
      showButtons: false,
    });
  };

  _handleConfirmClick = () => {
    const { type } = this.props;
    if (type === 'url') {
      this._handleConfirmUrlUpdate();
      return;
    }
    this._handleConfirmBidUpdate();
  };

  _submitForm = (ev) => {
    ev.preventDefault();
    this._handleConfirmClick();
    this.input && this.input.blur();
  };

  render() {
    const { input, showButtons } = this.state;
    const { type, id } = this.props;
    const inputWidth = type === 'bid' ? 'h_w-50' : 'h_w-100';
    return (
      <form
        className="da-form-flexbox"
        data-testid={`disco-ads-table-input-container-for-${id}`}
        onSubmit={this._submitForm}
      >
        <AccessInput
          className={inputWidth}
          inputClassName="table-input-tag"
          type="text"
          testid={`disco-ads-table-input-for-${id}`}
          value={input}
          onChange={this._handleInputChange}
          onFocus={this._handleInputIsInFocus}
          i13nLabel="Disco Ads Table Input"
          noFooter
          {...WRITE_PERMISSIONS.MOBILE_SEARCH}
        />
        {type === 'url' && !showButtons && (
          <Tooltip
            body={<span>{truncate(this.props.input, DA_CONTENT_URL_TOOLTIP_CHAR_LIMIT)}</span>}
            className="da-info-icon-tooltip-container"
          />
        )}
        {showButtons && (
          <div className="check-mark-icon__container">
            <ButtonIcon
              icon="check"
              className="check-mark-icon__box"
              iconClassName="check-mark-icon"
              testid={`disco-ads-table-input-for-${id}-confirm`}
              onClick={this._handleConfirmClick}
            />
          </div>
        )}
        {showButtons && (
          <div className="close-icon__container">
            <ButtonIcon
              icon="close"
              className="close-icon__box"
              iconClassName="close-icon"
              testid={`disco-ads-table-input-for-${id}-discard`}
              onClick={this._handleCloseClick}
            />
          </div>
        )}
      </form>
    );
  }
}

export default DiscoAdsTableInputWrapper;
